import React, { useState } from 'react'
import classes from 'classnames'

import styles from './StateSelect.module.scss'

const stateList = [
  '',
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
]

interface StatePropsType {
  disabled: boolean,
  onChange: (name: string, val: string | null) => void
}

const StateSelect = (props: StatePropsType) => {
  const {
    disabled = false,
    onChange
  } = props

  const [selectedState, setSelectedState] = useState<string>('')

  const onChangeHandler = (e: any) => {
    setSelectedState(e.target.value)
    return onChange(e.target.name, e.target.value)
  }

  const stateSelectClass = classes({
    [styles.stateSelect]: true,
    [styles.stateSelectValid]: selectedState !== ''
  })

  return (
    <div className={styles.stateContainer}>
      <select 
        id="addressState" 
        name="addressState" 
        className={stateSelectClass}
        disabled={disabled}
        onChange={onChangeHandler}>
        {stateList.map(state => {
          if (state === '') {
            return (<option key={'State'} value="">State</option>)
          }
          return (<option key={state} value={state}>{state}</option>)
        })}
      </select>
      { selectedState === '' ? (
          <div className={styles.requiredAsterisk}>
            <span><span className={styles.invisibleText}>State</span>*</span>
          </div>
        ) : null 
      }
      { selectedState === '' ? (
          <div className={styles.downArrowContainer}>
            <div className={styles.downArrow}></div>
          </div>
        ) : null
      }
    </div>
  )
}

export default StateSelect;
